import { DashboardDefaultLayout, DefaultSubscription } from './constant'
import { DashboardConfig, DashboardItem, DashboardItemList, PartialDashboard, SidebarItem, SidebarType, Subscription, SubscriptionType } from './types'

export type SubscriptionClassType = {
  type: SubscriptionType
  subscription?: Record<SubscriptionType, Subscription>
  layout?: Record<PartialDashboard, DashboardConfig>
}

export class SubscriptionClass {
  sidebar: SidebarType[]
  dashboard: PartialDashboard[]
  type: SubscriptionType
  subscription: Record<SubscriptionType, Subscription> = DefaultSubscription
  layout: Record<PartialDashboard, DashboardConfig> = DashboardDefaultLayout

  constructor(
    type: SubscriptionType = SubscriptionType.NO_SUBSCRIPTION,
    subscription: Record<SubscriptionType, Subscription> = DefaultSubscription,
    layout: Record<PartialDashboard, DashboardConfig> = DashboardDefaultLayout
  ) {
    this.type = type
    this.dashboard = subscription[type].dashboard
    this.sidebar = subscription[type].sidebar
    this.subscription = subscription
    this.layout = layout
  }

  getSidebarItems(sidebarItemsMap: Record<SidebarType, SidebarItem>): SidebarItem[] {
    const result: SidebarItem[] = []
    this.subscription[this.type].sidebar.forEach((item) => {
      result.push(sidebarItemsMap[item])
    })
    return result
  }

  getDashboardItems(dashboardItemList: DashboardItemList): DashboardItem[] {
    return this.dashboard.map((item) => {
      const { component } = dashboardItemList.find(({ label }) => label === item) ?? {}
      if (!component) {
        throw new Error(`Dashboard item ${item} not found`)
      }
      return {
        id: item,
        config: this.layout[item],
        component,
      }
    })
  }

  Type() {
    return this.type
  }
}
